import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaTimes } from "react-icons/fa";

const Navbar = () => {
    const [open, setOpen] = useState(false);

    return (
        <nav className="bg-white border-gray-200 px-2 sm:px-4 py-2.5 rounded dark:bg-gray-900 shadow-lg">
            <div className="container flex flex-wrap items-center justify-between mx-auto">
                <a href='/' className="flex items-center">
                    <span className="self-center text-3xl uppercase font-semibold whitespace-nowrap dark:text-white">
                        <span className='text-5xl text-cyan-700 font-bold'>E</span>
                        hsa
                        <span className='text-5xl text-cyan-700 font-bold'>N</span>
                    </span>
                </a>

                <div onClick={() => setOpen(!open)}>
                    {
                        open ?
                            <div className="inline-flex items-center p-3 ml-3 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600">
                                <FaTimes />
                            </div>
                            :
                            <button data-collapse-toggle="navbarOpen" type="button" className="inline-flex items-center p-2 ml-3 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="navbarOpen" aria-expanded="false">
                                <span className="sr-only">Open main menu</span>
                                <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd"></path></svg>
                            </button>
                    }
                </div>
                <div id="navbarOpen" className={`w-full md:block md:w-auto md:static absolute duration-500 ease-in ${open ? 'top-16' : 'top-[-500px]'}`}>
                    <ul className="flex flex-col p-4 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
                        <li className='hover:bg-gray-200 hover:rounded-lg p-2'>
                            <Link to='/' className="block py-2 pl-3 pr-4 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white" aria-current="page">Home</Link>
                        </li>
                        <li className='hover:bg-gray-200 hover:rounded-lg p-2'>
                            <Link to='/about' className="block py-2 pl-3 pr-4 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white" aria-current="page">About</Link>
                        </li>
                        <li className='hover:bg-gray-200 hover:rounded-lg p-2'>
                            <Link to='/allProjects' className="block py-2 pl-3 pr-4 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white" aria-current="page">Projects</Link>
                        </li>
                        <li className='hover:bg-gray-200 hover:rounded-lg p-2'>
                            <Link to='/blogs' className="block py-2 pl-3 pr-4 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white" aria-current="page">Blog</Link>
                        </li>
                        <li className='hover:bg-gray-200 hover:rounded-lg p-2'>
                            <a href='#contact' className="block py-2 pl-3 pr-4 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white" aria-current="page">Contact</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav >

    );
};

export default Navbar;